import type { ChangeEventHandler } from "react";
import { useId } from "react";

import { RadioButton } from "@jti/core-components";

import styles from "../ConsentBlock.module.scss";

type ConsentRadioInputProps = {
  name: string;
  value: string;
  label: string;
  selectedValue?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
};

export const ConsentRadioInput = ({ name, value, label, selectedValue, onChange }: ConsentRadioInputProps) => {
  const id = useId();

  return (
    <>
      <div className={styles.radioInput}>
        <RadioButton
          name={name}
          value={value}
          onChange={onChange}
          checked={value === selectedValue}
          id={id}
          label={label}
        />
      </div>
    </>
  );
};
